<p-toast></p-toast>
<div class="flex" style="height: 100vh; overflow: hidden;">
    <div class="login flex align-items-center justify-content-center">
        <div class="login-container flex flex-column gap-5">
            <img src="assets/icons/login-header.svg" width="156px" height="38px"/>
            <div class="login-description">
                <p>Que bom te ver <strong>por aqui de novo!</strong></p>
                <span>Informe seus dados para acessar sua conta</span>
            </div>
            <div class="login-container-form flex flex-column gap-3">
                <form [formGroup]="formAuth" class="flex flex-column gap-3">
                    <div class="flex flex-column gap-2">
                        <label for="email">Email</label>
                        <span class="p-input-icon-right">
                            <input formControlName="email" splitValidadorCampoFormulario class="w-full" pInputText type="email" id="email" > 
                        </span>
                    </div>
                    <div class="flex flex-column gap-2">
                        <label for="password">Senha</label>
                        <span class="p-input-icon-right">
                            <input formControlName="password" splitValidadorCampoFormulario class="w-full" pInputText type="password" id="password" > 
                        </span>
                    </div>
                    <p class="incorrect-label" *ngIf="error">Seu e-mail ou senha estão incorretos.</p>
                    <a [routerLink]="['/recuperar-senha']" class="forgot-password">Esqueceu sua senha?</a>
                    <button (click)="onSubmit()"  pRipple class="btn-login w-full h-3rem" pButton> 
                        <div class="text-center w-full">
                            Entrar
                        </div> 
                    </button>
                </form>
                <!--<div class="login-loading" *ngIf="loading">
                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner> 
                </div>-->
            </div>
        </div>
    </div>
    <div class="banner flex-1">
        <div class="banner-container flex flex-column gap-7">
            <p><strong>Gestão</strong> e <strong>automatização</strong> financeira integrado com a sua agenda</p>

            <div class="slide-container flex align-items-center">
                <div class="slide-content">
                    <div class="absolute">
                        <ul class="flex gap-7" [ngStyle]="{ 'transform': 'translateX(' + this.latX + 'px)' }">
                            <li *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': slide.active }" >
                                <img #img [src]="slide.img"> <!--  width="783px" height="418px" -->
                            </li>

                        </ul>
                    </div>
                    <p-button (click)="prevSlide()" class="btn-slide-prev" icon="pi pi-angle-left" [rounded]="true" severity="secondary" />
                    <p-button (click)="nextSlide()"  class="btn-slide-next" icon="pi pi-angle-right" [rounded]="true" severity="secondary" />
                </div>
            </div>
        </div>
    </div>
</div>


<!--<form [formGroup]="formAuth">
    <main class="flex justify-content-center absolute w-full h-full">
        <div class="login-container  flex flex-grow">
            <div class="flex-1 login-left-side">
                <div class="flex flex-1  justify-content-center align-items-center" style="flex-direction: column;">
                    <div class="flex justify-content-center p-5">
                        <img src="assets/icons/login-header.svg">
                    </div>
                    <div class="text-center">
                        <span class="lbl-gestao">
                            Conheça a Split Pay.<br/> 
                            O Software de Gestão<br/> 
                            <b>que resolve seus problemas</b>
                        </span>
                    </div>
                    <div class="flex justify-content-center w-full">
                        <img src="/assets/login/doctor.svg" style="max-width: 320px;">
                    </div>
                </div>
               
            </div>
            <div class="col-6 login-right-side relative p-0">
                <div class="flex absolute h-full w-full align-items-center" style="flex-direction:column">
                    <div class="flex flex-1 align-items-center justify-content-center w-full" style="flex-direction:column">
                        <div class="card card-container flex" style="flex-direction:column">
                            <div class="flex flex-1 align-items-center" style="flex-direction:column">
                                <div class="w-full flex justify-content-center mt-5 mb-5">
                                    <img src="assets/login/logo.svg">
                                </div>
                                <div>
                                    <h1 class="title">Entre na sua conta</h1>
                                    <p class="text-info-1">
                                        Facilite a sua gestão com uma ferramenta intuitiva
                                    </p>
                                </div>
                                <div class="pb-2">
                                    <input 
                                    formControlName="email" class="input-credentials w-25rem" pInputText  placeholder="Email" 
                                    splitValidadorCampoFormulario
                                    />
                                </div>
                                <div class="pb-4">
                                    <p-password 
                                    formControlName="password"
                                    placeholder="Senha"
                                    splitValidadorCampoFormulario
                                    
                                    [feedback]="false" [toggleMask]="true"></p-password>
                                    <p class="incorrect-label" *ngIf="error">Seu e-mail ou senha estão incorretos.</p>
                                </div>
                            
                                <div>
                                    <button (click)="onSubmit()" pRipple class="btn-login w-25rem h-3rem" pButton> 
                                        <div class="text-center w-full">
                                            Entrar
                                        </div> 
                                    </button>
                                </div>
                                <div>
                                    <p (click)="navigateForgotPassword()" class="forgot-password-text pb-4 cursor-pointer" pRipple> <b>Esqueci minha senha</b> </p>
                                </div>
                                <div>
                                    <button pRipple class="social-btn-login w-25rem hidden">
                                        <div class="flex flex-grow ">
                                            <div class="icon-container">
                                                <img src="/assets/login/google.svg" class="pr-5 pl-5">
                                            </div>
                                            <div class="flex-1">
                                                <p class="title text-left p-0 m-0">Entre com sua conta do Google</p>
                                                <p class="subtitle text-left p-0 m-0">Acesse agora mesmo</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <p class="signup">Ainda não é cliente ? <b><u style="color:var(--secondary-color)">Fale com um especialista</u></b></p>
                        </div>
                    </div>
                </div>
                <div class="loading" *ngIf="loading">
                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
                </div>
            </div>
        </div>
    </main>-->